
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1312Dialog extends Serenity.EntityDialog<Report_1312Row, any> {
        protected getFormKey() { return Report_1312Form.formKey; }
        protected getIdProperty() { return Report_1312Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1312Row.localTextPrefix; }
        protected getNameProperty() { return Report_1312Row.nameProperty; }
        protected getService() { return Report_1312Service.baseUrl; }
        protected getDeletePermission() { return Report_1312Row.deletePermission; }
        protected getInsertPermission() { return Report_1312Row.insertPermission; }
        protected getUpdatePermission() { return Report_1312Row.updatePermission; }

        protected form = new Report_1312Form(this.idPrefix);

    }
}